import React from "react";
import {
  FAQ,
  ImageText,
  NavigatorAbout,
  NavigatorSkills,
  TechRequiredClasses,
  FreeTrialPrograms,
} from "../../components";
import { inclusivityhero, navigatorhero } from "../../assets/images";
import { Helmet } from "react-helmet";

const Inclusivity = () => {
  const ideas = ["3D Modelling", "Game Design", "more"];

  return (
    <div>
      <Helmet>
        <title>Navigator Program: Tech Tails Private Virtual Classes</title>
        <meta
          name="description"
          content="A Tech Tails Program designed for individuals of all abilities, teaching practical tech skills for jobs and careers through personalized, one-on-one instruction."
        />
        <meta
          name="keywords"
          content="Tech Tails, Navigator, virtual tech classes, learn technology, Salt Lake City tech, personalized tech learning, special needs classes"
        />
      </Helmet>
      <ImageText
        title="Navigator"
        desc="A Tech Tails Program designed for individuals of all abilities, teaching practical tech skills for jobs and careers through personalized, one-on-one instruction."
        //   bgcolor="bg-pinkprimary"
        img={navigatorhero}
      />
      <NavigatorAbout />
      <NavigatorSkills ideas={ideas} />
      <FreeTrialPrograms />
      <TechRequiredClasses />
      <FAQ />
    </div>
  );
};

export default Inclusivity;

// Explorer Program
// Adventurer Program
// Onward Program
// Navigator Program
// Odyssey Program
// Quest Program
// Discover Program
// Pathfinder Program
